import StReportSdk from './st-report-sdk';

module.exports = module.exports['default'] = StReportSdk;



// WEBPACK FOOTER //
// ./src/index.ts